import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { errorMessage, successMessage } from "../../../utils/alertMessage";
import { addProcessFee, addProduct, getBankAccount, updateProcessFee, updateProduct } from "../../../services/userMasterUser";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { getUserData } from "../../../utils/localStorage";
import { Calendar } from "primereact/calendar";

export default function ProcessFeeCreate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, leadData } = location.state || {};

  const { userProfileData } = getUserData();

  const [bankDetailsList, setBankDetailsList] = useState([])

  const [input, setInput] = useState({
    paidOn: state?.paidOn ? new Date(state.paidOn) : new Date(),
    total: state?.total || "",
    paid: state?.paid || "",
    balance: state?.balance || "",
    fileNo: state?.fileNo || "",
    otherInfo: state?.otherInfo || "",
    status: state?.status || "ACTIVE",
    bankAccount: state?.bankAccount?.id || "",
  });
  const [errors, setErrors] = useState({
    paidOn: "",
    total: "",
    paid: "",
    balance: "",
    fileNo: "",
    otherInfo: "",
    status: "",
  });

  useEffect(() => {
    if (state) {
      setInput(prevState => ({
        ...prevState,
        status: state?.status,
      }));
    }
  }, [state]);

  useEffect(() => {
     getBankAccount()
          .then((response) => {
            if (!response.data.error) {
              const leadSource = response.data.map((item) => ({
                label: item.name,
                value: item.id,
              }));
              setBankDetailsList(leadSource)
            } else {
              errorMessage("Invalid Credentials");
            }
          })
          .catch(() => {
            errorMessage();
          })
  }, [])
  



  const [statusData, setStatusData] = useState([
    { label: "SUCCESS", value: "SUCCESS" },
    { label: "ACTIVE", value: "ACTIVE" },
    { label: "INACTIVE", value: "INACTIVE" }
  ]);

  const totalFees = Number(input.total) || 0;
  const paidFee = Number(input.paid) || 0;

  input.balance = totalFees - paidFee;

  const validateForm = () => {
    let isValid = true;
    const newErrors = { ...errors };

    // Example: Validate email format
    // const emailRegex = /^\S+@\S+\.\S+$/;
     
    if (!(input.fileNo)) {
      newErrors.fileNo = "Please Enter File No";
      isValid = false;
    } else {
      newErrors.fileNo = "";
    }
 
    if (!(input.otherInfo)) {
      newErrors.otherInfo = "Please Enter Other Info";
      isValid = false;
    } else {
      newErrors.otherInfo = "";
    }
    
    if (!(input.total)) {
      newErrors.total = "Please Enter Total";
      isValid = false;
    } else {
      newErrors.total = "";
    }

    if (!(input.paid)) {
      newErrors.paid = "Please Enter Paid";
      isValid = false;
    } else {
      newErrors.paid = "";
    }

    if (!(input.balance)) {
      newErrors.balance = "Please Enter Balance";
      isValid = false;
    } else {
      newErrors.balance = "";
    }

    if (!(input.paidOn)) {
      newErrors.paidOn = "Please Enter Paid On";
      isValid = false;
    } else {
      newErrors.paidOn = "";
    }

    if (!(input.bankAccount)) {
      newErrors.bankAccount = "Please Enter Bank Account";
      isValid = false;
    } else {
      newErrors.bankAccount = "";
    }
    
    // Add more validation logic for other fields as needed

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      if (state) {
        let data = {
          id: state?.id,
          paidOn: new Date(input?.paidOn).toISOString(),
          total: input?.total,
          paid: input?.paid,
          balance: input?.balance,
          status: input?.status,
          fileNo: input?.fileNo,
          otherInfo: input?.otherInfo,
          lead: {
            id: leadData?.lead?.id
          },
          bankAccount: {
            id: input.bankAccount
          },
          receivedBy: {
            id: userProfileData.id // received login profile id
          }
           
        };
        updateProcessFee(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/process-fee/list", { state: leadData });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      } else {
        let data = {
          paidOn: new Date(input?.paidOn).toISOString(),
          total: input?.total,
          paid: input?.paid,
          balance: input?.balance,
          status: input?.status,
          fileNo: input?.fileNo,
          otherInfo: input?.otherInfo,
          lead: {
            id: leadData?.lead?.id
          },
          bankAccount: {
            id: input.bankAccount
          },
          receivedBy: {
            id: userProfileData.id // received login profile id
          }
        };

        addProcessFee(data)
          .then((response) => {
            if (!response.data.error) {
              if (response.data.success === false) {
                successMessage(response.data.message);
              } else {
                successMessage(response.data.message);
                navigate("/process-fee/list", { state: leadData });
              }
            } else {
              // errorMessage(response.data.errors.errors[0].message);
            }
          })
          .catch((err) => {
            errorMessage();
          });
      }
    }
  };

  return (
    <main id="main" className="main">
      <section className="section main-color">
        <div className="row">
          <div className="col-lg-12">
            <div className="card-main">
              <div className="card-body">
                <h5 className="card-title flex">
                  <div
                    className="mr-3 cursor-pointer"
                    onClick={() => navigate("/process-fee/list", { state: leadData })}
                  >
                    <i class="bi bi-arrow-left-circle-fill"></i>
                  </div>Fee {state ? "Update" : "Create"}
                </h5>
                <form onSubmit={handleSubmit}>
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        File No
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="fileNo"
                        name="fileNo"
                        value={input.fileNo}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            fileNo: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.fileNo}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Other Info
                      </label>
                      <InputText
                        type="text"
                        style={{ width: "100%" }}
                        id="otherInfo"
                        name="otherInfo"
                        value={input.otherInfo}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            otherInfo: e.target.value,
                          });
                        }}
                        required
                      />
                      <div className="text-danger">{errors.otherInfo}</div>
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Total
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="total"
                        name="total"
                        value={input.total}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            total: e.target.value,
                          });
                        }}
                        required
                        onWheel={(e) => e.target.blur()} // prevent mouse scroll
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault(); // prevent arrow increment/decrement
                          }
                        }}
                      />
                      <div className="text-danger">{errors.total}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Paid
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="paid"
                        name="paid"
                        value={input.paid}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            paid: e.target.value,
                          });
                        }}
                        required
                        onWheel={(e) => e.target.blur()} // prevent mouse scroll
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault(); // prevent arrow increment/decrement
                          }
                        }}
                      />
                      <div className="text-danger">{errors.paid}</div>
                    </div>
                    
                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Balance
                      </label>
                      <InputText
                        type="number"
                        style={{ width: "100%" }}
                        id="balance"
                        name="balance"
                        value={input.balance}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            balance: e.target.value,
                          });
                        }}
                        readOnly
                        onWheel={(e) => e.target.blur()} // prevent mouse scroll
                        onKeyDown={(e) => {
                          if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                            e.preventDefault(); // prevent arrow increment/decrement
                          }
                        }}
                      />
                      <div className="text-danger">{errors.balance}</div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="score" className="form-label">
                        Paid On
                      </label>
                      <Calendar
                        id="paidOn"
                        value={input.paidOn}
                        onChange={(e) =>
                          setInput({
                            ...input,
                            paidOn: e.value,
                          })
                        }
                        showIcon
                        dateFormat="dd/mm/yy"
                        maxDate={new Date()}
                        style={{ width: "100%" }}
                      />
                      <div className="text-danger">{errors.paidOn}</div>
                    </div>

                  </div>

                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label htmlFor="bankAccount" className="form-label">
                        Bank Account
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={bankDetailsList}
                        value={input.bankAccount}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            bankAccount: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.bankAccount}</div>
                    </div>
                     <div className="col-md-6">
                      <label htmlFor="status" className="form-label">
                        Status
                      </label>
                      <Dropdown
                        style={{ width: "100%" }}
                        options={statusData}
                        value={input.status}
                        onChange={(e) => {
                          setInput({
                            ...input,
                            status: e.value,
                          });
                        }}
                      />
                      <div className="text-danger">{errors.status}</div>
                    </div>
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="move-btn move-btn-blue">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
